export const formatGameMode = (mode) => {
  switch (mode) {
    case 0:
      return "H2H Rookie";
    case 1:
      return "H2H PRO";
    case 2:
      return "H2H VETERAN";
    case 3:
      return "H2H CHAMP";
    case 4:
      return "SEASON";
    case 5:
      return "DAILY";
    default:
      return "Unknown";
  }
};

export const formatEntry = (mode) => {
  switch (mode) {
    case 0:
      return "50";
    case 1:
      return "150";
    case 2:
      return "300";
    case 3:
      return "500";
    case 4:
      return "--";
    case 5:
      return "--";
    default:
      return "--";
  }
};

export const formatPrize = (mode) => {
  switch (mode) {
    case 0:
      return "85";
    case 1:
      return "270";
    case 2:
      return "560";
    case 3:
      return "975";
    case 4:
      return "--";
    case 5:
      return "--";
    default:
      return "--";
  }
};

export const formatRecord = (wins, losses) => {
  return `${wins || 0}-${losses || 0}`;
};

export const getGameModeColor = (mode) => {
  switch (mode) {
    case 0:
      return "success"; // H2H Rookie - green
    case 1:
      return "primary"; // H2H PRO - blue
    case 2:
      return "warning"; // H2H VETERAN - orange
    case 3:
      return "error"; // H2H CHAMP - red
    case 4:
      return "info"; // SEASON - light blue
    case 5:
      return "secondary"; // DAILY - gray
    default:
      return "default"; // Unknown - default
  }
};
